// React Imports
import { useState, useEffect } from 'react';


// MUI Imports
import Grid from "@mui/material/Grid";

// Component Imports
import AddCard from "./AddCard";

// Data Imports
const getInvoiceData = async () => {
  return [
    {
      id: 1,
      stock_item: "Vin",
      quantite: 4,
      unite: "carton",
      type_client: "client_particulier",
      client_particulier: "John Doe",
      Adresse_facturation: "123 Rue, Ville",
      magasin_id: 3,
    },
  ];
};


const FactureAddForm = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await getInvoiceData();
      setData(result);

    };

    fetchData();
  }, []);

  return (
      <AddCard invoiceData={data} />      
  );
};

export default FactureAddForm;
